module.exports = __webpack_public_path__ + "static/media/cnn.com_2016_07_08_us_philando-castile-alton-sterling-protests_index.html_plot.a4ed46e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/cnn.com_2016_07_08_us_philando-castile-alton-sterling-protests_index.html_plot.png
// module id = 374
// module chunks = 0